import React from 'react'

const PageSubHeader = (props) => {
  const {pageName, pageMenu1, pageMenu2, pageMenu, className = ''} = props

  return (
    <div className={'d-flex align-items-center ' + className}>
      <div className='fs-28 sm-fs-20 f-b flex-full'>{pageName}</div>
      <div className='fs-13 color-9e9e9e sm-none'>{pageMenu1}<img className='a4_r' src={'/assets/image/a4_r.png'} alt='' /></div>
      {
        (pageMenu2 != null && pageMenu2 !== '') &&
        <div className='fs-13 color-9e9e9e sm-none'>{pageMenu2}<img className='a4_r' src={'/assets/image/a4_r.png'} alt='' /></div>
      }
      <div className='fs-13 sm-fs-20 f-m sm-none'>{pageMenu}</div>
    </div>
  )
}

export default PageSubHeader
